import {
  faBullhorn,
  faCheck,
  faCoins,
  faCreditCardAlt,
  faHandshake,
  faLock,
  faPhotoVideo,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Checkbox } from "@material-tailwind/react";
import { useRef, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { userSubscriptionOffers_offers } from "../../Api/types";
import Button from "../../Component/Input/Button";
import { FormatPrice } from "../../Component/utils";
import TextInput from "../../Component/Input/TextInput";
const ACheckbox = Checkbox as any;

function SubsChooseOffer({
  subOffers,
  promo,
  index,
  setIndex,
  nextStep,
  tryCode,
}: {
  tryCode: any;
  promo: boolean;
  nextStep: any;
  subOffers: userSubscriptionOffers_offers[];
  index: number;
  setIndex: any;
}) {
  const intl = useIntl();
  const [codeError, setCodeError] = useState<any>();
  const [error, setError] = useState<any>();
  const [code, setCode] = useState("");

  const [canNext, setCanNext] = useState(false);
  return (
    <>
      <div className="bg-cards p-4 flex flex-col gap-2 rounded-b-xl px-12">
        <div className="font-semibold">
          <FormattedMessage id="popin__upgrade_account_features_title" />
        </div>
        <div className="text-xs flex gap-2 items-center">
          <FontAwesomeIcon className="w-4 mr-4 text-primary" icon={faCheck} />
          <FormattedMessage id="popin__upgrade_account_feature_6" />
        </div>
        <div className="text-xs flex gap-2 items-center">
          <FontAwesomeIcon className="w-4 mr-4 text-primary" icon={faLock} />
          <FormattedMessage id="popin__upgrade_account_feature_2" />
        </div>
        <div className="text-xs flex gap-2 items-center">
          <FontAwesomeIcon
            className="w-4 mr-4 text-primary"
            icon={faPhotoVideo}
          />
          <FormattedMessage id="popin__upgrade_account_feature_8" />
        </div>
        <div className="text-xs flex gap-2 items-center">
          <FontAwesomeIcon
            className="w-4 mr-4 text-primary"
            icon={faBullhorn}
          />
          <FormattedMessage id="popin__upgrade_account_feature_5" />
        </div>
      </div>
      <div className="flex gap-4 text-xs justify-around px-4 my-4">
        <div className="flex flex-col items-center gap-3 text-center">
          <svg
            className="text-white h-10"
            fill="currentcolor"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 58.08 47.9"
          >
            <defs></defs>
            <g id="Calque_2" data-name="Calque 2">
              <g id="Calque_1-2" data-name="Calque 1">
                <g id="Groupe_11968" data-name="Groupe 11968">
                  <path
                    id="Tracé_32345"
                    data-name="Tracé 32345"
                    className="cls-1"
                    d="M7.26,47.9a.88.88,0,0,1-.38-1.68C11.6,44,16.1,44.43,20.45,44.88a39.85,39.85,0,0,0,7.72.28c6.18-.57,12.21-4.2,17.53-7.4a61.6,61.6,0,0,0,7.71-5.3l.39-.32c.79-.63,2.62-2.12,2.53-3,0-.47-.24-.56-.33-.6-.9-.43-3.54.07-11,4.88-.44.28-.75.48-.9.56a.89.89,0,0,1-1.21-.32.88.88,0,0,1,.33-1.2l0,0c.13-.07.41-.25.8-.5,4.9-3.14,10.24-6.19,12.75-5a2.34,2.34,0,0,1,1.32,2c.2,1.86-1.91,3.56-3.17,4.58l-.36.3a63.27,63.27,0,0,1-7.88,5.42C41.11,42.56,34.9,46.3,28.32,46.9a40.22,40.22,0,0,1-8.06-.28c-4.3-.44-8.36-.86-12.64,1.19A1.12,1.12,0,0,1,7.26,47.9Z"
                  />
                  <path
                    id="Tracé_32346"
                    data-name="Tracé 32346"
                    className="cls-1"
                    d="M31.15,38.68c-1.33,0-2.66-.1-4-.2a29.84,29.84,0,0,0-6.68,0,.88.88,0,0,1-1-.71.87.87,0,0,1,.71-1h.05a31,31,0,0,1,7.08,0c2.94.21,5.72.42,8.37-.42s3.91-1.78,3.73-2.63c-.22-1.14-3-1.43-4.24-1.55l-.46,0c-.86-.1-1.77-.16-2.65-.22a28.31,28.31,0,0,1-5.79-.79,26.13,26.13,0,0,1-3.73-1.49,21.25,21.25,0,0,0-4-1.52C13.46,26.89,10,29.82,6.31,32.93a39.08,39.08,0,0,1-4.94,3.74.88.88,0,0,1-1-1.47l.08,0a37.21,37.21,0,0,0,4.71-3.58C9,28.34,13,25,18.94,26.35A22.84,22.84,0,0,1,23.27,28a23.59,23.59,0,0,0,3.48,1.39,26.18,26.18,0,0,0,5.43.73c.9.06,1.82.12,2.73.23l.44,0c1.86.19,5.31.54,5.79,2.95.39,1.94-1.27,3.5-4.93,4.66A16.67,16.67,0,0,1,31.15,38.68Z"
                  />
                  <path
                    id="Tracé_32347"
                    data-name="Tracé 32347"
                    className="cls-1"
                    d="M28.25,8.35a.88.88,0,0,1-.88-.88h0V6.39a.9.9,0,0,1,.91-.85.88.88,0,0,1,.85.85V7.47A.87.87,0,0,1,28.25,8.35Z"
                  />
                  <path
                    id="Tracé_32348"
                    data-name="Tracé 32348"
                    className="cls-1"
                    d="M15,21.63H13.9a.89.89,0,0,1-.91-.85.88.88,0,0,1,.85-.91H15a.87.87,0,0,1,.9.85.88.88,0,0,1-.85.91Z"
                  />
                  <path
                    id="Tracé_32349"
                    data-name="Tracé 32349"
                    className="cls-1"
                    d="M42.61,21.63H41.53a.89.89,0,0,1-.91-.85.88.88,0,0,1,.85-.91h1.14a.87.87,0,0,1,.9.85.88.88,0,0,1-.85.91Z"
                  />
                  <path
                    id="Tracé_32350"
                    data-name="Tracé 32350"
                    className="cls-1"
                    d="M21.61,10.13a.89.89,0,0,1-.76-.44l-.54-.93a.88.88,0,0,1,1.5-.93l0,0,.53.93a.87.87,0,0,1-.32,1.2.83.83,0,0,1-.44.12Z"
                  />
                  <path
                    id="Tracé_32351"
                    data-name="Tracé 32351"
                    className="cls-1"
                    d="M39.75,15a.88.88,0,0,1-.44-1.64l.93-.54a.88.88,0,0,1,.93,1.49l-.05,0-.93.54A.86.86,0,0,1,39.75,15Z"
                  />
                  <path
                    id="Tracé_32352"
                    data-name="Tracé 32352"
                    className="cls-1"
                    d="M34.89,10.13A.88.88,0,0,1,34,9.25a.83.83,0,0,1,.12-.44l.54-.93a.88.88,0,1,1,1.55.83l0,0-.54.93A.89.89,0,0,1,34.89,10.13Z"
                  />
                  <path
                    id="Tracé_32353"
                    data-name="Tracé 32353"
                    className="cls-1"
                    d="M16.75,15a.88.88,0,0,1-.44-.12l-.93-.54a.88.88,0,0,1,.88-1.52h0l.93.54a.88.88,0,0,1,.33,1.2.89.89,0,0,1-.77.44Z"
                  />
                  <path
                    id="Tracé_32354"
                    data-name="Tracé 32354"
                    className="cls-1"
                    d="M40.68,28.8a1,1,0,0,1-.44-.11l-.93-.54a.88.88,0,0,1,.88-1.52l.93.53a.89.89,0,0,1,.33,1.2.85.85,0,0,1-.77.44Z"
                  />
                  <path
                    id="Tracé_32355"
                    data-name="Tracé 32355"
                    className="cls-1"
                    d="M47.16,27.8a.87.87,0,0,1-.88-.88.84.84,0,0,1,0-.27A19,19,0,1,0,9.64,24.58a.88.88,0,0,1-1.73.35,21,21,0,0,1-.42-4.18,20.77,20.77,0,1,1,41.53,0,21.11,21.11,0,0,1-1,6.41A.88.88,0,0,1,47.16,27.8Z"
                  />
                  <path
                    id="Tracé_32356"
                    data-name="Tracé 32356"
                    className="cls-1"
                    d="M28.26,22.16a.85.85,0,0,1-.62-.26L20.77,15A.88.88,0,0,1,22,13.78L28.27,20l4.24-4.24A.88.88,0,0,1,33.76,17L28.89,21.9A.88.88,0,0,1,28.26,22.16Z"
                  />
                </g>
              </g>
            </g>
          </svg>
          <FormattedMessage id="popin__upgrade_account_reinsurance1" />
        </div>
        <div className="flex flex-col items-center gap-3 text-center">
          <svg
            className="text-white h-10"
            fill="currentcolor"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 53.34 47.91"
          >
            <defs></defs>
            <g id="Calque_2" data-name="Calque 2">
              <g id="Calque_1-2" data-name="Calque 1">
                <g id="Groupe_11966" data-name="Groupe 11966">
                  <g id="Groupe_11965" data-name="Groupe 11965">
                    <path
                      id="Tracé_32322"
                      data-name="Tracé 32322"
                      className="cls-1"
                      d="M26.67,14.38a7.19,7.19,0,1,1,7.19-7.19h0A7.2,7.2,0,0,1,26.67,14.38Zm0-12.76a5.57,5.57,0,1,0,5.57,5.57h0A5.57,5.57,0,0,0,26.67,1.62Z"
                    />
                  </g>
                  <path
                    id="Tracé_32323"
                    data-name="Tracé 32323"
                    className="cls-1"
                    d="M32.34,30.69a.81.81,0,0,1-.81-.81V23.77a3.82,3.82,0,0,1,1.53-3.05l7.88-6.41a1.48,1.48,0,0,0,.47-2.05l0-.07A1.46,1.46,0,0,0,39.31,12l0,0L34,15.93a12.29,12.29,0,0,1-14.65,0L14.08,12a1.67,1.67,0,0,0-1.16-.35,1.3,1.3,0,0,0-.94.53,1.35,1.35,0,0,0-.26,1.08,1.7,1.7,0,0,0,.65,1l7.94,6.45a3.79,3.79,0,0,1,1.5,3v6.11a.81.81,0,1,1-1.62,0h0V23.77A2.19,2.19,0,0,0,19.31,22l-7.93-6.45a3.23,3.23,0,0,1-1.25-2,3,3,0,0,1,.55-2.33,3,3,0,0,1,2.08-1.18,3.3,3.3,0,0,1,2.29.67l5.26,3.92a10.65,10.65,0,0,0,12.72,0l5.27-3.92a3,3,0,1,1,3.87,4.69l-.23.17L34.05,22a2.21,2.21,0,0,0-.9,1.78v6.1A.81.81,0,0,1,32.34,30.69Z"
                  />
                  <path
                    id="Tracé_32324"
                    data-name="Tracé 32324"
                    className="cls-1"
                    d="M40.69,39.52A1.66,1.66,0,0,1,39,37.85a2.64,2.64,0,0,1,0-.28l.65-3.79-2.77-2.72a1.67,1.67,0,0,1,0-2.35,1.62,1.62,0,0,1,1-.49l3.8-.55,1.74-3.48a1.66,1.66,0,0,1,1.49-.92h0a1.67,1.67,0,0,1,1.49.92h0l1.7,3.45,3.84.58a1.67,1.67,0,0,1,1.41,1.88,1.74,1.74,0,0,1-.49,1l-2.75,2.68.63,3.83a1.65,1.65,0,0,1-1.35,1.92,1.7,1.7,0,0,1-1.06-.17l-3.4-1.79-3.44,1.79A1.65,1.65,0,0,1,40.69,39.52Zm4.2-3.6a1.57,1.57,0,0,1,.77.19l3.4,1.79.87-.19-.8.14-.65-3.79A1.64,1.64,0,0,1,49,32.59l2.76-2.69,0-.08-3.8-.55a1.66,1.66,0,0,1-1.25-.91l-1.7-3.45s0,0,0,0l-1.74,3.47a1.68,1.68,0,0,1-1.26.91l-3.8.55,0,.08,2.76,2.69a1.64,1.64,0,0,1,.47,1.47l-.64,3.79.06,0,3.4-1.79a1.65,1.65,0,0,1,.78-.2Z"
                  />
                  <path
                    id="Tracé_32325"
                    data-name="Tracé 32325"
                    className="cls-1"
                    d="M4.26,39.52A1.66,1.66,0,0,1,2.6,37.85a1.27,1.27,0,0,1,0-.28l.65-3.79L.5,31.06a1.66,1.66,0,0,1,0-2.35,1.62,1.62,0,0,1,1-.49l3.81-.55L7,24.19a1.68,1.68,0,0,1,1.5-.92h0a1.67,1.67,0,0,1,1.49.92l1.7,3.45,3.83.58a1.67,1.67,0,0,1,.93,2.84l-2.76,2.68.64,3.83a1.66,1.66,0,0,1-2.41,1.75l-3.4-1.79L5,39.32A1.61,1.61,0,0,1,4.26,39.52Zm0-1.67.07,0h0l3.4-1.79a1.7,1.7,0,0,1,1.55,0l3.4,1.79.06,0L12,34.06a1.7,1.7,0,0,1,.48-1.48l2.76-2.68,0-.08-3.8-.55a1.68,1.68,0,0,1-1.26-.91l-1.7-3.45h0s0,0,0,0L6.71,28.36a1.66,1.66,0,0,1-1.25.91l-3.81.55,0,.08,2.75,2.69a1.67,1.67,0,0,1,.48,1.47l-.65,3.79Z"
                  />
                  <path
                    id="Tracé_32326"
                    data-name="Tracé 32326"
                    className="cls-1"
                    d="M32.45,47.91a2,2,0,0,1-.93-.23l-4.68-2.46a.4.4,0,0,0-.34,0l-4.68,2.46a2,2,0,0,1-2.68-.83,2,2,0,0,1-.2-1.26l.9-5.21a.35.35,0,0,0-.11-.32L16,36.37a2,2,0,0,1,0-2.81A2.08,2.08,0,0,1,17.05,33l5.23-.76a.36.36,0,0,0,.28-.2l2.34-4.74a2,2,0,0,1,3.55,0L30.79,32a.36.36,0,0,0,.28.2L36.3,33A2,2,0,0,1,38,35.23a2,2,0,0,1-.58,1.14l-3.79,3.69a.37.37,0,0,0-.1.32l.9,5.21a2,2,0,0,1-1.63,2.3l-.33,0Zm-5.78-4.35a2,2,0,0,1,.93.23l4.68,2.46a.36.36,0,0,0,.49-.15.37.37,0,0,0,0-.23l-.9-5.22a2,2,0,0,1,.57-1.75l3.79-3.69a.37.37,0,0,0,0-.52.43.43,0,0,0-.21-.11l-5.23-.76a2,2,0,0,1-1.5-1.08L27,28h0a.37.37,0,0,0-.49-.17.37.37,0,0,0-.16.17L24,32.74a2,2,0,0,1-1.5,1.08l-5.23.76A.36.36,0,0,0,17,35a.35.35,0,0,0,.1.21l3.78,3.69a2,2,0,0,1,.57,1.75l-.89,5.22a.38.38,0,0,0,.3.42.37.37,0,0,0,.23,0l4.68-2.46A2,2,0,0,1,26.67,43.56Z"
                  />
                </g>
              </g>
            </g>
          </svg>
          <FormattedMessage id="popin__upgrade_account_reinsurance3" />
        </div>
        <div className="flex flex-col items-center gap-3 text-center">
          <svg
            className="text-white h-10"
            fill="currentcolor"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 47.92 47.91"
          >
            <defs></defs>
            <g id="Calque_2" data-name="Calque 2">
              <g id="Calque_1-2" data-name="Calque 1">
                <g id="Groupe_11967" data-name="Groupe 11967">
                  <path
                    id="Tracé_32327"
                    data-name="Tracé 32327"
                    className="cls-1"
                    d="M24,4.32a.72.72,0,0,1-.72-.72h0V1.93a.73.73,0,0,1,.75-.7.74.74,0,0,1,.7.7V3.6A.73.73,0,0,1,24,4.32Z"
                  />
                  <path
                    id="Tracé_32328"
                    data-name="Tracé 32328"
                    className="cls-1"
                    d="M24,46.71a.73.73,0,0,1-.72-.73V44.31a.73.73,0,0,1,.75-.7.74.74,0,0,1,.7.7V46A.74.74,0,0,1,24,46.71Z"
                  />
                  <path
                    id="Tracé_32329"
                    data-name="Tracé 32329"
                    className="cls-1"
                    d="M3.6,24.68H1.94a.73.73,0,0,1,0-1.45H3.6a.72.72,0,0,1,.7.75A.73.73,0,0,1,3.6,24.68Z"
                  />
                  <path
                    id="Tracé_32330"
                    data-name="Tracé 32330"
                    className="cls-1"
                    d="M46,24.68H44.32a.73.73,0,0,1,0-1.45H46a.73.73,0,0,1,.7.75A.74.74,0,0,1,46,24.68Z"
                  />
                  <path
                    id="Tracé_32331"
                    data-name="Tracé 32331"
                    className="cls-1"
                    d="M9.57,10.28a.72.72,0,0,1-.52-.21L7.88,8.89a.72.72,0,0,1,0-1,.73.73,0,0,1,1,0l1.18,1.18a.73.73,0,0,1-.51,1.24Z"
                  />
                  <path
                    id="Tracé_32332"
                    data-name="Tracé 32332"
                    className="cls-1"
                    d="M39.54,40.25A.72.72,0,0,1,39,40l-1.17-1.18a.72.72,0,0,1,1-1L40.05,39a.74.74,0,0,1,0,1,.71.71,0,0,1-.51.21Z"
                  />
                  <path
                    id="Tracé_32333"
                    data-name="Tracé 32333"
                    className="cls-1"
                    d="M8.39,40.25A.72.72,0,0,1,7.88,39l1.18-1.17a.71.71,0,0,1,1,0,.72.72,0,0,1,0,1L8.9,40A.69.69,0,0,1,8.39,40.25Z"
                  />
                  <path
                    id="Tracé_32334"
                    data-name="Tracé 32334"
                    className="cls-1"
                    d="M38.36,10.28a.73.73,0,0,1-.73-.72.7.7,0,0,1,.22-.51L39,7.87a.73.73,0,0,1,1,1l-1.18,1.18A.69.69,0,0,1,38.36,10.28Z"
                  />
                  <path
                    id="Tracé_32335"
                    data-name="Tracé 32335"
                    className="cls-1"
                    d="M15.07,3.21a.73.73,0,0,1-.67-.45L13.67,1a.72.72,0,0,1,.4-.94A.71.71,0,0,1,15,.45l.73,1.76a.72.72,0,0,1-.39.94A.67.67,0,0,1,15.07,3.21Z"
                  />
                  <path
                    id="Tracé_32336"
                    data-name="Tracé 32336"
                    className="cls-1"
                    d="M33.59,47.91a.74.74,0,0,1-.68-.45l-.72-1.76a.71.71,0,0,1,.42-.93.72.72,0,0,1,.92.38l.72,1.76a.71.71,0,0,1-.39.94.67.67,0,0,1-.28.06Z"
                  />
                  <path
                    id="Tracé_32337"
                    data-name="Tracé 32337"
                    className="cls-1"
                    d="M.73,34.3A.71.71,0,0,1,0,33.58a.73.73,0,0,1,.46-.68l1.75-.73a.73.73,0,0,1,.56,1.35L1,34.24A.67.67,0,0,1,.73,34.3Z"
                  />
                  <path
                    id="Tracé_32338"
                    data-name="Tracé 32338"
                    className="cls-1"
                    d="M45.43,15.79a.73.73,0,0,1-.27-1.4l1.75-.73A.73.73,0,0,1,47.47,15l-1.76.73A.67.67,0,0,1,45.43,15.79Z"
                  />
                  <path
                    id="Tracé_32339"
                    data-name="Tracé 32339"
                    className="cls-1"
                    d="M2.49,15.79a.71.71,0,0,1-.28-.06L.46,15A.72.72,0,0,1,1,13.66l1.76.73a.73.73,0,0,1-.28,1.4Z"
                  />
                  <path
                    id="Tracé_32340"
                    data-name="Tracé 32340"
                    className="cls-1"
                    d="M47.19,34.3a.92.92,0,0,1-.28,0l-1.75-.73a.73.73,0,0,1-.37-1,.72.72,0,0,1,.92-.38l1.76.73a.73.73,0,0,1-.28,1.4Z"
                  />
                  <path
                    id="Tracé_32341"
                    data-name="Tracé 32341"
                    className="cls-1"
                    d="M14.34,47.91a.73.73,0,0,1-.72-.73.81.81,0,0,1,.05-.27l.73-1.76a.73.73,0,0,1,1.34.56L15,47.46A.73.73,0,0,1,14.34,47.91Z"
                  />
                  <path
                    id="Tracé_32342"
                    data-name="Tracé 32342"
                    className="cls-1"
                    d="M32.86,3.21a.67.67,0,0,1-.28-.06.71.71,0,0,1-.39-.94L32.91.45A.73.73,0,0,1,34.26,1h0l-.73,1.76A.73.73,0,0,1,32.86,3.21Z"
                  />
                  <path
                    id="Tracé_32343"
                    data-name="Tracé 32343"
                    className="cls-1"
                    d="M24,41.33A17.38,17.38,0,1,1,41.34,24h0A17.4,17.4,0,0,1,24,41.33ZM24,8A15.93,15.93,0,1,0,39.89,24,15.92,15.92,0,0,0,24,8Z"
                  />
                  <path
                    id="Tracé_32344"
                    data-name="Tracé 32344"
                    className="cls-1"
                    d="M22.26,32.45h0a3.8,3.8,0,0,1-2.68-1.11l-5-5A3.79,3.79,0,1,1,19.91,21l2.35,2.35L28,17.55a3.79,3.79,0,0,1,5.36,5.36l-8.44,8.43A3.76,3.76,0,0,1,22.26,32.45Zm-5-11.16a2.33,2.33,0,0,0-1.65,4l5,5a2.36,2.36,0,0,0,1.66.69h0a2.33,2.33,0,0,0,1.65-.69l8.44-8.43a2.34,2.34,0,0,0-3.17-3.43.8.8,0,0,0-.13.13h0l-6.27,6.26a.71.71,0,0,1-1,0L18.89,22A2.35,2.35,0,0,0,17.23,21.29Z"
                  />
                </g>
              </g>
            </g>
          </svg>
          <FormattedMessage id="popin__upgrade_account_reinsurance4" />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4 px-4 ">
        {subOffers.map((e, i) => (
          <div
            className={
              "bg-cards w-full relative border text-white p-4 overflow-hidden cursor-pointer flex flex-col gap-2 rounded-xl" +
              (index === i ? " border-primary" : " border-cards")
            }
            onClick={() => setIndex(i)}
          >
            {e.iframe_url && (
              <div className="text-primary text-center w-full text-xs font-bold">
                AUDIOTEL
              </div>
            )}

            <div className="text-center">
              {e.days < 30 ? e.days : Math.round(e.days / 30)}{" "}
              {e.days < 30 ? (
                <FormattedMessage id="popin__subscription_duration_day_singular" />
              ) : (
                <FormattedMessage
                  id={
                    "popin__subscription_duration_month_" +
                    (Math.round(e.days / 30) === 1 ? "singular" : "plural")
                  }
                />
              )}{" "}
              + {e.tokens} <FontAwesomeIcon icon={faCoins} />
            </div>
            <div className="flex gap-1 uppercase font-semibold justify-center">
              <FormatPrice currency={e.currency} price={e.price} />
            </div>
            <div className="bg-popinbg h-4 w-4 rounded-full m-auto relative">
              {index === i && (
                <>
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-primary opacity-50 h-6 w-6 rounded-full"></div>
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center bg-primary h-4 w-4 rounded-full">
                    <FontAwesomeIcon className="h-3" icon={faCheck} />
                  </div>
                </>
              )}
              {index !== i && (
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 border-2 border-tabs h-5 w-5 rounded-full"></div>
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="m-auto flex items-center px-4 text-xs ">
        <ACheckbox
          id="conditions"
          onChange={(e: any) => setCanNext(e.target.checked)}
        />
        <label
          htmlFor="conditions"
          className="[&>a]:underline"
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({ id: "register__terms" }),
          }}
        ></label>
      </div>
      <div className="px-4">
        <Button
          fillSpace
          name="ephemeviewer__next_epheme"
          color="primary"
          onClick={
            canNext
              ? nextStep
              : () => setError("popin__upgrade_account_pay_error_message")
          }
        />
      </div>
      {error && (
        <div className="text-center px-4  text-red-600">
          <FormattedMessage id={error} />
        </div>
      )}
      {!promo && (
        <div
          className={
            "mx-4 p-2 rounded-md border flex flex-col gap-2 " +
            (codeError ? "border-red-600" : "border-border")
          }
        >
          <div className="text-center">
            <FormattedMessage id="promocode__title" />
          </div>
          <div className="flex gap-2">
            <div className="flex-1 [&>*>input]:h-12">
              <TextInput onChange={(e) => setCode(e.target.value)} />
            </div>
            <Button
              name="promocode__button"
              className={"!rounded-md mt-1"}
              onClick={() => {
                setCodeError(false);
                tryCode(code).then((e?: string) => {
                  if (e) setCodeError(e);
                });
              }}
              color="primary"
            />
          </div>
          {codeError && (
            <div className="text-center text-red-600">
              <FormattedMessage id="promocode__error_code" />
            </div>
          )}
        </div>
      )}
      <div className="flex px-4  justify-between text-xs">
        <div>
          <FontAwesomeIcon className="mr-1" icon={faCreditCardAlt} />
          <FormattedMessage id="popin__upgrade_account_secured_payement" />
        </div>
        <div>
          <FontAwesomeIcon className="mr-1" icon={faHandshake} />
          <FormattedMessage id="popin__upgrade_account_anonymous" />
        </div>
      </div>
      <div className="text-xs px-4  text-center">
        <FormattedMessage id="popin__upgrade_account_bank_note" />
      </div>
      <div className="text-xs px-4  text-center">
        <FormattedMessage id="popin__upgrade_account_service_provider" />
      </div>
    </>
  );
}

export default SubsChooseOffer;
